module.exports = __webpack_public_path__ + "img/sls.702286fd.svg";